import semver from 'semver';

export type TSortationDefaultStyles = {
  baseColor: string;
  baseColorOpacity: number;
  baseOutline: 0 | 1 | boolean;
  baseOutlineColor: string;
  baseBorderRadius: number;
  score: 0 | 1 | boolean;
  showCorrectAnswer: 0 | 1 | boolean;
  panelBackground: string;
  panelBackgroundDragging: string;
  textColor: string;
  textColorDragging: string;
  optionBorderRadius: number;
  optionBackgroundOpacity: number;
  optionBackgroundOpacityDragging: number;
  optionOutline: boolean;
  optionOutlineColor: string;
  includeText: boolean;
  imagePosition: string;
};

export const sortationDefaultStyles = {
  base: {
    baseColor: '#ECEDF0',
    baseColorOpacity: 100,
    baseOutline: false,
    baseOutlineColor: 'transparent',
    baseBorderRadius: 10,
    score: true,
    showCorrectAnswer: false,
    panelBackground: '#282A2B',
    panelBackgroundDragging: '#949595',
    textColor: '#fff',
    textColorDragging: '#000',
    optionBorderRadius: 5,
    optionBackgroundOpacity: 100,
    optionBackgroundOpacityDragging: 100,
    optionOutline: false,
    optionOutlineColor: '',
    includeText: true,
    imagePosition: 'top',
  },
  '1.5.0': {
    baseColor: '#F0F0F6',
    baseColorOpacity: 100,
    baseOutline: false,
    baseOutlineColor: 'transparent',
    baseBorderRadius: 20,
    score: true,
    showCorrectAnswer: false,
    panelBackground: '#FFFFFF',
    panelBackgroundDragging: '#B2B6CA',
    textColor: '#000000',
    textColorDragging: '#000000',
    optionBorderRadius: 12,
    optionBackgroundOpacity: 100,
    optionBackgroundOpacityDragging: 100,
    optionOutline: false,
    optionOutlineColor: '',
    includeText: true,
    imagePosition: 'top',
  },
};

export const getDefaultStyles = (blockMetaPackageVersion: string = '') => {
  if (!blockMetaPackageVersion || !semver.valid(blockMetaPackageVersion)) {
    return sortationDefaultStyles['base'];
  }

  if (semver.gte(blockMetaPackageVersion, '1.5.0')) {
    return sortationDefaultStyles['1.5.0'];
  }
  //

  return sortationDefaultStyles['base'];
};
